import React from 'react';
import { motion } from 'framer-motion';
import { GitGraph, Zap, Radio, Activity, Lock, History } from 'lucide-react';
const features = [{
  icon: GitGraph,
  title: 'Cascade Builder',
  description: 'Drag-and-drop visual workflow canvas. Design automations as intuitive node graphs.'
}, {
  icon: Zap,
  title: 'Pulse Triggers',
  description: 'Smart event listeners that fire workflows instantly — on schedule, webhook, or data change.'
}, {
  icon: Radio,
  title: 'Nexus Connectors',
  description: '200+ pre-built integrations. Slack, Notion, Airtable, HubSpot, Stripe, and beyond.'
}, {
  icon: Activity,
  title: 'Meridian Dashboard',
  description: 'Real-time monitoring with live status, throughput metrics, and failure alerts.'
}, {
  icon: Lock,
  title: 'Veil Permissions',
  description: 'Granular role-based access. Control who sees, edits, or triggers each workflow.'
}, {
  icon: History,
  title: 'Echo Logs',
  description: 'Full execution history with step-by-step replay for debugging and compliance.'
}];
export function FeaturesSection() {
  return <section id="features" className="py-24 bg-sky-50/30 relative" data-id="element-22">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-23">
        <div className="text-center mb-16" data-id="element-24">
          <span className="text-sky-600 font-semibold tracking-wider uppercase text-sm" data-id="element-25">
            Features
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mt-2 mb-4" data-id="element-26">
            Built for Flow, Not Friction
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-27">
            Everything you need to build, run, and monitor complex automations
            at scale.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-28">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="relative bg-white p-8 rounded-2xl shadow-sm border border-slate-100 hover:shadow-md hover:border-sky-200 transition-all group" data-id="element-29">
              {/* Node connection points decoration */}
              <div className="absolute -top-1.5 left-1/2 -translate-x-1/2 w-3 h-3 bg-slate-100 rounded-full border border-slate-200 group-hover:bg-sky-400 group-hover:border-sky-500 transition-colors" data-id="element-30"></div>
              <div className="absolute -bottom-1.5 left-1/2 -translate-x-1/2 w-3 h-3 bg-slate-100 rounded-full border border-slate-200 group-hover:bg-sky-400 group-hover:border-sky-500 transition-colors" data-id="element-31"></div>

              <div className="w-14 h-14 bg-sky-50 rounded-xl flex items-center justify-center text-sky-600 mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-32">
                <feature.icon size={28} data-id="element-33" />
              </div>

              <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-sky-600 transition-colors" data-id="element-34">
                {feature.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-35">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}